var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"title"},[_vm._v("清除缓存")]),_c('div',{staticStyle:{"margin":"16px"}},[_c('van-button',{attrs:{"type":"info","round":"","block":""},on:{"click":_vm.onClearCache}},[_vm._v("点击清除")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }